import { render, staticRenderFns } from "./ChatDistributionsByPlatform.vue?vue&type=template&id=7acb21a3&scoped=true"
import script from "./ChatDistributionsByPlatform.vue?vue&type=script&lang=js"
export * from "./ChatDistributionsByPlatform.vue?vue&type=script&lang=js"
import style0 from "./ChatDistributionsByPlatform.vue?vue&type=style&index=0&id=7acb21a3&prod&lang=scss"
import style1 from "./ChatDistributionsByPlatform.vue?vue&type=style&index=1&id=7acb21a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acb21a3",
  null
  
)

export default component.exports